import { gql } from '@apollo/client';

export const BADGE_BASICS = gql`
  fragment BadgeBasics on Badge {
    __typename
    lastEarnedTime
    thumbUrl
    title
  }
`;
